import { Brand, I18NText, State } from 'src/types'
import { getAtomsFirstMittColorCells } from 'src/features/brands/atoms/simulationSpecification'
import { getDxMFirstMittColorCells } from 'src/features/brands/dxm/simulationSpecification'
import { getGorillaFirstMittColorCells } from 'src/features/brands/gorilla/simulationSpecification'
import { getRagDeLionFirstMittColorCells } from 'src/features/brands/ragdelion/simulatedSpecification'

export const genFirstMittColorCells = (state: State, brand: Brand, t: I18NText) => {
  switch (brand) {
    case 'atoms':
      return getAtomsFirstMittColorCells(state, t)
    case 'ragdelion':
      return getRagDeLionFirstMittColorCells(state, t)
    case 'dxm':
      return getDxMFirstMittColorCells(state, t)
    case 'gorilla':
      return getGorillaFirstMittColorCells(state, t)
    // case 'treasure':
    //   return [
    //     ...commonFirstMittColorCells,
    //     isTreasureEmblem && genFirstMittColorCell('Treasureエンブレム', state.treasureOriginalParts, 'treasureOriginalParts'),
    //     genFirstMittColorCell('Treasureラベル(メイン)', state.treasureLabelMain, 'treasureLabelMain'),
    //     genFirstMittColorCell('Treasureラベル(影)', state.treasureLabelShadow, 'treasureLabelShadow'),
    //     genFirstMittColorCell('Treasureラベル(台)', state.treasureLabelStand, 'treasureLabelStand')
    //   ].filter(Boolean)
  }
}
